import { Search, Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

function TopNavbar({
  searchTerm = "",
  setSearchTerm = () => {},
}) {
  const navigate = useNavigate();

  return (
    <header
      className="
        bg-gradient-to-r
        from-white
        via-red-50
        to-white
        border-b
        border-red-100
        shadow-sm
      "
    >
      {/* Desktop Navbar */}
      <div
        className="
        hidden
        lg:flex
        h-20
        px-8
        items-center
        justify-between
      "
      >
        {/* Left */}
        <div>
          <h1 className="text-xl font-semibold text-gray-900">
            We ❤️{" "}
            <span className="text-gray-900">
              LIGHTSPEED PHOTONICS
            </span>
          </h1>
        </div>

        {/* Search */}
        <div className="flex-1 max-w-2xl mx-10">
          <div className="relative">
            <Search
              size={18}
              className="
                absolute
                left-4
                top-1/2
                -translate-y-1/2
                text-gray-400
              "
            />

            <input
              type="text"
              placeholder="Search applications..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
              className="
                w-full
                pl-11
                pr-4
                py-3
                rounded-xl
                bg-white
                border
                border-red-100
                shadow-sm
                focus:outline-none
                focus:ring-2
                focus:ring-red-200
              "
            />
          </div>
        </div>

        {/* Right */}
        <div className="flex items-center gap-4">
          <button
            className="
              relative
              p-3
              rounded-xl
              bg-white
              border
              border-red-100
              hover:bg-red-50
            "
          >
            <Bell size={20} />

            <span
              className="
                absolute
                top-2
                right-2
                w-2.5
                h-2.5
                rounded-full
                bg-[#C00000]
              "
            />
          </button>

          <div
            onClick={() =>
              navigate("/dashboard/profile")
            }
            className="
              flex
              items-center
              gap-3
              px-3
              py-2
              rounded-xl
              bg-white
              border
              border-red-100
              cursor-pointer
            "
          >
            <div
              className="
                w-10
                h-10
                rounded-full
                bg-[#C00000]
                text-white
                flex
                items-center
                justify-center
                font-semibold
              "
            >
              U
            </div>

            <div>
              <p className="text-sm font-medium">
                User
              </p>

              <p className="text-xs text-gray-500">
                Employee
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navbar */}
      <div
        className="
        lg:hidden
        px-4
        py-3
      "
      >
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-lg font-semibold text-gray-900">
              Dashboard
            </h1>

            <p className="text-xs text-gray-500">
              Lightspeed Photonics
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              className="
                relative
                p-2
                rounded-lg
                bg-white
                border
                border-red-100
              "
            >
              <Bell size={18} />

              <span
                className="
                  absolute
                  top-1.5
                  right-1.5
                  w-2
                  h-2
                  rounded-full
                  bg-[#C00000]
                "
              />
            </button>

            <div
              onClick={() =>
                navigate("/dashboard/profile")
              }
              className="
                w-9
                h-9
                rounded-full
                bg-[#C00000]
                text-white
                flex
                items-center
                justify-center
                font-semibold
                cursor-pointer
              "
            >
              U
            </div>
          </div>
        </div>

        {/* Mobile Search */}
        <div className="mt-3">
          <div className="relative">
            <Search
              size={16}
              className="
                absolute
                left-3
                top-1/2
                -translate-y-1/2
                text-gray-400
              "
            />

            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
              className="
                w-full
                pl-10
                pr-3
                py-2.5
                rounded-xl
                border
                border-red-100
                bg-white
                text-sm
                focus:outline-none
                focus:ring-2
                focus:ring-red-200
              "
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default TopNavbar;